/* eslint-disable @typescript-eslint/no-inferrable-types */
/* eslint-disable @typescript-eslint/no-explicit-any */
import {
  Component,
  computed,
  HostListener,
  inject,
  Injector,
  OnInit,
  PLATFORM_ID,
  signal,
} from "@angular/core";
import { assets } from "../../core/constants/assets.const";
import { ButtonModule } from "primeng/button";
import { RouterModule } from "@angular/router";
import { CommonModule, isPlatformBrowser } from "@angular/common";
import { FormsModule } from "@angular/forms";
import { InputTextModule } from "primeng/inputtext";
import { DrawerModule } from "primeng/drawer";
import { ProgressBarModule } from "primeng/progressbar";
import { OverlayBadgeModule } from "primeng/overlaybadge";
import { MenuModule } from "primeng/menu";
import { UserType, UserTypeService } from "../../service/user-type.service";
import { DialogService, DynamicDialogRef } from "primeng/dynamicdialog";
import { NewMcqSetComponent } from "../../dialogs/new-mcq-set/new-mcq-set.component";
import { MenuItem } from "primeng/api";
import { AddEmployeeComponent } from "../../dialogs/add-employee/add-employee.component";
import { AddNewMemberComponent } from "../../dialogs/add-new-member/add-new-member.component";
import { RadioButtonModule } from "primeng/radiobutton";
import { BaseClass } from "../class/BaseClass";
import { LoginResponse } from "../../models/auth.model";
import { Subject, Subscription, takeUntil } from "rxjs";
import { takeUntilDestroyed } from "@angular/core/rxjs-interop";
import { ROLES } from "../../core/constants/keys.const";
import { ConfirmDialogService } from "../../service/confirm-dialog.service";
import { environment } from "../../../environments/environment";
import { ChooseMembersComponent } from "../../dialogs/choose-members/choose-members.component";
import { CommonLayoutComponent } from "../../modules/afterLoginpages/common-layout/common-layout/common-layout.component";
@Component({
  selector: "notchmark-header",
  imports: [
    ButtonModule,
    RouterModule,
    CommonModule,
    FormsModule,
    InputTextModule,
    DrawerModule,
    ProgressBarModule,
    OverlayBadgeModule,
    MenuModule,
    RadioButtonModule,
    CommonLayoutComponent,
  ],
  providers: [DialogService],
  templateUrl: "./header.component.html",
  styleUrl: "./header.component.scss",
})
export class HeaderComponent extends BaseClass implements OnInit {
  
  drawer: boolean = false;
  isMobile = false;
  menuItems: MenuItem[] = [];
  uploadMenuItems: MenuItem[] = [{}];
  ref: DynamicDialogRef | undefined;
  assetsConst = assets;
  isScrolled = false;
  visible1 = false;
  visible2 = false;
  public _userType: UserType | null = null;
  logoLink = "/";
  
  private userTypeService = inject(UserTypeService);
  private dialogservice = inject(DialogService);
  protected profile = signal<LoginResponse | null>(null);
  protected savedItemsCount = computed(() => this.profile()?.savedItemsCount ?? 0);  
  protected subscriptionSubject$!: Subscription;
  private platformId = inject(PLATFORM_ID);
  private destroy = new Subject<void>();
  private confirmationService = inject(ConfirmDialogService);
  uploadMenu: any;
  // eslint-disable-next-line @angular-eslint/prefer-inject
  constructor(injector: Injector) {
    super(injector);

    this.subscriptionSubject$ = this._authService.profileDetails
      .pipe(takeUntilDestroyed(this.destroyRef$))
      .subscribe({
        next: (res: LoginResponse | null) => {
          if (res) {            
            const profileData = (res as LoginResponse).data
              ? (res as any).data
              : res;
            this.profile.set(profileData);
            const role = profileData.role;
            this._userType = this.mapRoleToUserType(role);
            this.setLogoLink();
            this.buildMenu();
          } else {
            if (isPlatformBrowser(this.platformId)) {
              this.getProfile();
            }
          }
        },
      });
  }

  private getProfile(): void {
    this._authService
      .getProfile()
      .pipe(takeUntilDestroyed(this.destroyRef$))
      .subscribe((res: LoginResponse | null) => {
        if (res) {
          this.profile.set(res);
          this._userType = this.mapRoleToUserType(res.role);
          this.setLogoLink();
          this.buildMenu();
          this._authService.profileDetails.next(res);
        }
      });
  }

  private mapRoleToUserType(role: any): UserType | null {
    switch (role) {
      case ROLES.STUDENT:
        return "student";
      case ROLES.TUTOR:
        return "tutor";
      case ROLES.BUSINESS_ADMIN:
        return "business";
      case ROLES.BUSINESS_MEMBER:
        return "business-member";
      case ROLES.ADMIN:
      case ROLES.SUBADMIN:
        return null;
      default:
        return null;
    }
  }

  addEmployee() {
    this.ref = this.dialogservice.open(AddEmployeeComponent, {
      style: { width: "100%", maxWidth: "750px" },
      dismissableMask: true,
      styleClass: "add_employee_modal",
      data: {
        title: "Add Employees",
        subTitle: "Upload Members File",
        description:
          'You can upload an Members file from here or drag and <span class="d_block"> drop. (CSV/Excel)</span>',
        uploadType: "member", // Key to identify which API to call
      },
    });
    this.ref.onClose.subscribe((result) => {
      if (result && result.success) {
        console.log("Upload successful");
      }
    });
  }
  addBulEmployee() {
    this.ref = this.dialogservice.open(AddNewMemberComponent, {
      style: { width: "100%", maxWidth: "504px" },
      dismissableMask: true,
      styleClass: "add_employee_modal",
    });
  }

  @HostListener("window:scroll", [])
  onWindowScroll() {
    this.isScrolled = window.scrollY > 50;
  }

  ngOnInit() {
    if (this._userType) {
      this.buildMenu();
    }
    this.setLogoLink();
    this.checkScreen();
  }
  @HostListener("window:resize")
  onResize() {
    this.checkScreen();
  }
  checkScreen() {
    this.isMobile = window.innerWidth <= 1200;
  }
  openDrawer() {
    if (this.isMobile) {
      this.drawer = true;
    }
  }

    closeDrawer(event: boolean) {
    // Add a 300ms delay to allow routerLink to execute first
    setTimeout(() => {
      this.drawer = event;
    }, 300);
  }
  // closeDrawer(event: boolean) {
  //   this.drawer = event;
  // }

  private setLogoLink(): void {
    if (this._userType === "student") {
      this.logoLink = "/student-dashboard";
    } else if (this._userType === "business") {
      this.logoLink = "/business/dashboard";
    } else if (this._userType === "tutor") {
      this.logoLink = "/tutor/dashboard";
    } else {
      this.logoLink = "/";
    }
  }
  newmcqset() {
    this.ref = this.dialogservice.open(NewMcqSetComponent, {
      style: { width: "100%", maxWidth: "770px" },
      data: { name: "Add" },
    });
  }

  buildMenu() {
    if (this._userType === "student") {
      this.menuItems = [
        {
          label: "My Profile",
          icon: this.assetsConst.singleUserIcon,
          path: "/account/my-profile",
        },
        {
          label: "My Tests",
          icon: this.assetsConst.sidebarIcon,
          path: "/my-tests",
        },
        {
          label: "My Report & Progress",
          icon: this.assetsConst.sidebarIcon2,
          path: "/students/reports",
        },
        {
          label: "Logout",
          icon: this.assetsConst.sidebarIcon8,
          command: () => this.btn_logOut(),
        },
      ];
    } else if (this._userType === "business-member") {
      this.menuItems = [
        {
          label: "My Profile",
          icon: this.assetsConst.singleUserIcon,
          path: "/account/my-profile",
        },
        {
          label: "My Tests",
          icon: this.assetsConst.sidebarIcon,
          path: "/my-tests",
        },
        {
          label: "My Report & Progress",
          icon: this.assetsConst.sidebarIcon2,
          path: "/students/reports",
        },
        {
          label: "Logout",
          icon: this.assetsConst.sidebarIcon8,
          command: () => this.btn_logOut(),
        },
      ];
    } else if (this._userType === "tutor") {
      this.menuItems = [
        {
          label: "My Profile",
          icon: this.assetsConst.singleUserIcon,
          path: "/tutor/my-profile",
        },
        {
          label: " My Earnings",
          icon: this.assetsConst.sidebarIcon9,
          path: "/tutor/manage-earning",
        },
        {
          label: " Manage MCQ Sets",
          icon: this.assetsConst.sidebarIcon2,
          path: "/mcq-sets",
        },
        {
          label: "Logout",
          icon: this.assetsConst.sidebarIcon8,
          command: () => this.btn_logOut(),
        },
      ];
    } else if (this._userType === "business") {
      this.menuItems = [
        {
          label: "My Profile",
          icon: this.assetsConst.singleUserIcon,
          path: "/account/my-profile",
        },
        {
          label: "Purchased Sets/Test",
          icon: this.assetsConst.singleUserIcon,
          path: "/business/purchases",
        },
        {
          label: "Members",
          icon: this.assetsConst.sidebarIcon,
          path: "/business/members",
        },
        {
          label: "Assignments",
          icon: this.assetsConst.sidebarIcon2,
          path: "/business/assignments",
        },
        {
          label: "Logout",
          icon: this.assetsConst.sidebarIcon8,
          command: () => this.btn_logOut(),
        },
      ];
    }
  }

  visible = false;
  ingredient!: string;
  ingredients = [
    { id: "m1", label: "3 months", value: "3m" },
    {
      id: "m2",
      label: "6 months",
      value: "6m",
      tag: "Save 10%",
      tagClass: "c_primary",
    },
    {
      id: "m3",
      label: "12 months",
      value: "12m",
      tag: "Save 20%",
      tagClass: "c_success",
    },
  ];
  priceList = [
    { label: "Seats to renew", value: "30" },
    { label: "Unit Price per sear", value: "1" },
    { label: "Subtotal(6 months)", value: "3600 SAR" },
    { label: "VAT(15%):", value: "886 SAR" },
    { label: "Total:", value: "3726 SAR", isTotal: true },
  ];

  btn_logOut(): void {
    this.confirmationService
      .showConfirmationDialog(" ", this._translateService.instant("SureLogout"))
      .then((result) => {
        if (result) {
          this._authService
            .logout()
            .pipe(takeUntil(this.destroy))
            .subscribe({
              next: () => {
                localStorage.removeItem(environment.storageKey);
                this.profile.set(null);
                this._authService.profileDetails.next(null);
                this.router.navigate(["/landing-page"]);
              },
            });
        }
      });
  }
  handleKeyDown(event: KeyboardEvent, action: string): void {
    if (event.key === "Enter" || event.key === " ") {
      event.preventDefault();

      switch (action) {
        case "uploadMenu":
          this.uploadMenu.toggle(event);
          break;
        case "selectmcqset":
          this.selectmcqset();
          break;
        case "newmcqset":
          this.newmcqset();
          break;
        case "addEmployee":
          this.addEmployee();
          break;
        case "addBulEmployee":
          this.addBulEmployee();
          break;
      }
    }
  }

  selectmcqset() {
    this.ref = this.dialogservice.open(ChooseMembersComponent, {
      style: { width: "100%" },
      dismissableMask: true,
    });
  }
}
